import { APILibrary, ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { UserProfileResource } from 'util/resources/UserProfile';
import { Base, Collection } from 'active-resource';
import { HiringHeroConfigResource } from './HiringHeroConfig';
import { ProfileQuestionResource } from 'util/resources/ProfileQuestion';

/**
 * Relationship classes
 */
export class GeographyAttributes {
  id: string = null;
  descriptiveLabel: string = null;
  longName: string = null;
  salesPhoneNumber: string = null;
  displayNeighborhoodLocations: boolean;
  shortName: string = null;
  zoomLevel: number = null;
  latitude: string = null;
  longitude: string = null;
}

export class GeographyBelongsTo {}
export class GeographyHasOne {}

export class GeographyHasMany {
  userProfiles: () => Collection<UserProfileResource> = () => new Collection<UserProfileResource>();
  hiringHeroConfigs: () => Collection<HiringHeroConfigResource> = () =>
    new Collection<HiringHeroConfigResource>();
  profileQuestions: () => Collection<ProfileQuestionResource> = () =>
    new Collection<ProfileQuestionResource>();
}

/**
 * Utility interfaces
 */
export interface GeographyMethods {}

export interface GeographyInterface extends GeographyAttributes, GeographyHasMany, GeographyType {}

type GeographyType = GConstructor<GeographyInterface>;

export interface GeographyResource
  extends Base<GeographyAttributes>,
    GeographyInterface,
    GeographyMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<GeographyAttributes>({
    queryName: 'geographies',
    className: 'Geography',
    AttributesClass: GeographyAttributes,
    HasManyClasses: [
      {
        Klass: GeographyHasMany,
      },
    ],
  });

export const GeographyResourceClass = <TBase extends GeographyType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements GeographyMethods {};

export class GeographyResource extends ClassExtender<GeographyInterface>(
  BaseClass,
  GeographyResourceClass,
) {}

/**
 * Resource instance
 */
export const Geography = APILibrary.createResource<GeographyResource>(GeographyResource);
